<template>
  <b-form-rating v-model="fieldScore"></b-form-rating>
</template>

<script>
export default {
  name: 'ScoreInput',
  props: {
    data: {}
  },
  data() {
    return {
      fieldScore: ''
    }
  },
  watch: {
    fieldScore(newValue) {
      this.$emit('changeValue', {
        field_type: 'score',
        value: newValue,
        field_id: this.data.id
      })
    }
  }
}
</script>

<style lang="scss">
.b-rating-star-full {
  color: #F1DA0D !important;
}

.b-rating-star-empty {
  color: #E6E6E6!important;
}
</style>



// WEBPACK FOOTER //
// src/parts/components/rating/fields/fieldScore.vue